import * as React from "react";
import * as ReactDOM from "react-dom";
import { useDragState } from "./DragContext";
import { dragManager } from "./DragManager";

interface DragOverlayProps {
  children?: React.ReactNode;
}

export const DragOverlay: React.FC<DragOverlayProps> = ({ children }) => {
  const { isDragging } = useDragState();
  // Tracked locally so that pointer moves only re-render the overlay
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

  React.useEffect(() => {
    if (!isDragging) {
      return;
    }
    const { mouseX, mouseY } = dragManager.getState();
    setMousePosition({ x: mouseX, y: mouseY });
    return dragManager.onDragMove((x, y) => setMousePosition({ x, y }));
  }, [isDragging]);

  if (!isDragging) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        left: mousePosition.x + 10,
        top: mousePosition.y + 10,
        pointerEvents: "none",
        zIndex: 9999,
        opacity: 0.8,
        transform: "translate3d(0, 0, 0)",
      }}
    >
      {children}
    </div>,
    document.body,
  );
};
